// PresentationEditorBridge — receives inline text edits from the Discovery
// presentation iframe and forwards them to LiveView for autosave and, on blur,
// for Monica to reconcile against the room sources (docs/board).
export default {
  mounted() {
    this.onMessage = (event) => {
      if (event.source !== this.el.contentWindow) return

      const payload = event.data || {}
      if (payload.type !== "discovery_presentation:autosave_text") return

      const discoveryId = this.el.dataset.discoveryId || ""
      if (payload.discovery_id && discoveryId && payload.discovery_id !== discoveryId) return

      this.pushEvent("presentation:autosave_text", {
        discovery_id: discoveryId,
        slide_index: payload.slide_index,
        slide_id: payload.slide_id,
        slide_kind: payload.slide_kind,
        slide_title: payload.slide_title,
        field: payload.field,
        previous_text: payload.previous_text,
        replacement_text: payload.replacement_text,
        review_needed: payload.review_needed === true,
      })
    }

    window.addEventListener("message", this.onMessage)
  },

  destroyed() {
    window.removeEventListener("message", this.onMessage)
  },
}
